import { render } from "./Commodities.vue?vue&type=template&id=48143d35&ts=true"
import script from "./Commodities.vue?vue&type=script&lang=ts"
export * from "./Commodities.vue?vue&type=script&lang=ts"

import "./Commodities.vue?vue&type=style&index=0&id=48143d35&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__